export enum ESteam {
  TRADE_LINK = 'TRADE_LINK',
  API_KEY = 'API_KEY',
  LINK = 'LINK',
}
